import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import CourseListSection from './CourseListSection';
import InputAdornment from '@mui/material/InputAdornment';

import SearchIcon from '@mui/icons-material/Search';

import AddEntityCard from '@ts-core/components/AddEntityCard';

const useStyles = makeStyles((theme) => ({
  searchTextField: {
    marginBottom: theme.spacing(1),
  },
}));

const CoursesList = (props) => {
  const classes = useStyles();
  const { sections: pSections, filterQuery, loading, onSelectCourse, onEditCourse, onRemoveCourse, onFilterCourses, onAddCourse } = props;

  const sections = loading ? Array.from(new Array(2)) : pSections;

  const handleSearchTextFieldChange = useCallback(
    (event) => {
      onFilterCourses(event.target.value);
    },
    [onFilterCourses]
  );

  return (
    <Box display="flex" flexDirection="column" py={2}>
      {onFilterCourses && (
        <TextField
          disabled={loading || (sections.length === 0 && !filterQuery)}
          fullWidth
          label={<FormattedMessage id="coursesPage.searchCourse.placeholder" />}
          id="simple-start-adornment"
          className={classes.searchTextField}
          onChange={handleSearchTextFieldChange}
          value={filterQuery || ''}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      )}

      {sections.map((section, index) => (
        <CourseListSection
          key={index}
          section={section}
          loading={loading}
          onSelectCourse={onSelectCourse}
          onEditCourse={onEditCourse}
          onRemoveCourse={onRemoveCourse}
        />
      ))}
      {!loading && pSections.length === 0 && !filterQuery && (
        <Box maxWidth={320} mt={2}>
          <AddEntityCard message={<FormattedMessage id="button.addCourse.title" variant="body2" />} onAdd={onAddCourse} />
        </Box>
      )}
    </Box>
  );
};

CoursesList.propTypes = {
  sections: PropTypes.array,
  loading: PropTypes.bool,
  filterQuery: PropTypes.string,

  onFilterCourses: PropTypes.func,
  onAddCourse: PropTypes.func,
  onSelectCourse: PropTypes.func.isRequired,
  onRemoveCourse: PropTypes.func,
  onEditCourse: PropTypes.func,
};

CoursesList.defaultProps = {
  sections: [],
  filterQuery: undefined,
  onFilterCourses: undefined,
  loading: false,
  onRemoveCourse: undefined,
  onEditCourse: undefined,
  onAddCourse: undefined,
};

export default CoursesList;
